"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconMedal = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10.4503 13.134L11.0337 11.234L9.50032 10.0007H11.4003L12.0003 8.13398L12.6003 10.0007H14.5003L12.9503 11.234L13.5337 13.134L12.0003 11.9507L10.4503 13.134ZM8.00033 19.334V14.184C7.5781 13.7173 7.25033 13.184 7.01699 12.584C6.78366 11.984 6.66699 11.3451 6.66699 10.6673C6.66699 9.17843 7.18366 7.91732 8.21699 6.88398C9.25032 5.85065 10.5114 5.33398 12.0003 5.33398C13.4892 5.33398 14.7503 5.85065 15.7837 6.88398C16.817 7.91732 17.3337 9.17843 17.3337 10.6673C17.3337 11.3451 17.217 11.984 16.9837 12.584C16.7503 13.184 16.4225 13.7173 16.0003 14.184V19.334L12.0003 18.0007L8.00033 19.334ZM12.0003 14.6673C13.1114 14.6673 14.0559 14.2784 14.8337 13.5007C15.6114 12.7229 16.0003 11.7784 16.0003 10.6673C16.0003 9.55621 15.6114 8.61176 14.8337 7.83398C14.0559 7.05621 13.1114 6.66732 12.0003 6.66732C10.8892 6.66732 9.94477 7.05621 9.16699 7.83398C8.38921 8.61176 8.00033 9.55621 8.00033 10.6673C8.00033 11.7784 8.38921 12.7229 9.16699 13.5007C9.94477 14.2784 10.8892 14.6673 12.0003 14.6673Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconMedal')(IconMedal);